export * from '@primeuix/themes/material/inlinemessage';
export { default } from '@primeuix/themes/material/inlinemessage';
